import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDNUrIElZQulYfRvigm5BTm1Y8JpnrK6dA",
  authDomain: "spaceflightio.firebaseapp.com",
  projectId: "spaceflightio",
  storageBucket: "spaceflightio.appspot.com",
  messagingSenderId: "442647295498",
  appId: "1:442647295498:web:c4ba4be5771ce60d0611f3",
  measurementId: "G-GHNT80DBL6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


const db = getFirestore(app)
const auth = getAuth(app)




export {db, auth}

